import React from "react";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Dropdown from "../../../common/dropdown";
import LABELS from "../../../../constants/labels/motor.labels";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import useMotorFacade from "../../../../facade/calculation/calculation-output/motor-facade";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";

const Sensor = () => {
    const { sensorCollapse } = useAppSelector((state) => state?.collapse);
    const { updateESPEquipmentsForMotorSensor } = useMotorFacade();
    const { updateSchematicEquipmentData } = useCalculationFacade();
    const { UpdatehiddenMotorSensor } = useTubingFacade();


    const { updateSensorCollapse } = useCollapseFacade();
    const { EquipmentsForSensor, ESPEquipmentsForSensor } = useAppSelector(state => state?.motor);
    const { tab1Input } = useAppSelector(state => state?.tubing);//hdnMotr_Sensr

    const handleCollapseChange = (key: boolean) => {
        updateSensorCollapse(key);
    };
    var esp: any;

    const handleChangeMotorSensorEquipment = (equipments: any) => {
        UpdatehiddenMotorSensor(equipments?.id);
        updateESPEquipmentsForMotorSensor([equipments]);
        updateSchematicEquipmentData();
    };
    if (ESPEquipmentsForSensor[0]) {
        esp = [...ESPEquipmentsForSensor]
        esp = esp.map((item: any) => ({
            ...item,
            id: tab1Input?.hdnMotr_Sensr,
            value: tab1Input?.hdnMotr_Sensr
        }));
    }

    const EspEquipmentsClear = () => {
        updateESPEquipmentsForMotorSensor([]);
        updateSchematicEquipmentData();
    };
    return (
        <Accordion
            title="Sensor"
            isOpen={sensorCollapse}
            onToggle={() => handleCollapseChange(!sensorCollapse)}
            content={<>
                <div className="flex justify-center items-start p-4 gap-4 w-full">
                    <EquipmentTableAddChargePump
                    isMotorListSensorMode={true}
                        options={EquipmentsForSensor.map((item: any) => {
                            return {
                                ...item,
                                label: item?.text,
                                value: item?.id,
                            };
                        })}
                        equipments={
                            esp?.length > 0
                                ? esp
                                : [{}]
                        }
                        onClear={EspEquipmentsClear}
                        onChange={handleChangeMotorSensorEquipment}
                        rowLength={1}
                        equipmentGridParentContainer='SRMotorSensor'
                    />
                </div>

            </>}
        />
    );
};

export default Sensor;
